/**
 * Station field name for filters
 */
type DetailCheckboxType = 'ENERGY' | 'VEHICLE' | 'PAYMENT';
const DetailCheckboxType = (() => {
  const ENERGY: DetailCheckboxType = 'ENERGY';
  const VEHICLE: DetailCheckboxType = 'VEHICLE';
  const PAYMENT: DetailCheckboxType = 'PAYMENT';

  function values(): DetailCheckboxType[] {
    return [ENERGY, VEHICLE, PAYMENT];
  }
  return { ENERGY, VEHICLE, PAYMENT, values };
})();

export { DetailCheckboxType };
